// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables(after, areaIds, before, first, forSalePropertyTypes, forSaleStatuses, keywords, last, maxBeds, maxPrice, minBeds, minPrice, offMlsOnly, rentalMode, rentalPropertyTypes, rentalStatuses, sortOrder, useForSaleInventory, useForSaleProperties) {
  return {
    after: after,
    areaIds: areaIds,
    before: before,
    first: first,
    forSalePropertyTypes: forSalePropertyTypes,
    forSaleStatuses: forSaleStatuses,
    keywords: keywords,
    last: last,
    maxBeds: maxBeds,
    maxPrice: maxPrice,
    minBeds: minBeds,
    minPrice: minPrice,
    offMlsOnly: offMlsOnly,
    rentalMode: rentalMode,
    rentalPropertyTypes: rentalPropertyTypes,
    rentalStatuses: rentalStatuses,
    sortOrder: sortOrder,
    useForSaleInventory: useForSaleInventory,
    useForSaleProperties: useForSaleProperties
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function forSalePropertyV5FilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "UNDER_CONTRACT" || $$enum === "SOLD") {
    return $$enum;
  }
}

let forSalePropertyV5FilterableStatus_fromString = forSalePropertyV5FilterableStatus_decode;

function propertySearchSortOrder_decode($$enum) {
  if ($$enum === "RECENTLY_BROADCAST" || $$enum === "RECENTLY_UPDATED_EXCLUDING_RENEWALS" || $$enum === "RECENTLY_UPDATED") {
    return $$enum;
  }
}

let propertySearchSortOrder_fromString = propertySearchSortOrder_decode;

function rentalPropertyFilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "RENTED") {
    return $$enum;
  }
}

let rentalPropertyFilterableStatus_fromString = rentalPropertyFilterableStatus_decode;

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let rentalPropertyTypeEnumV5_fromString = rentalPropertyTypeEnumV5_decode;

let Utils = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  forSalePropertyV5FilterableStatus_decode: forSalePropertyV5FilterableStatus_decode,
  forSalePropertyV5FilterableStatus_fromString: forSalePropertyV5FilterableStatus_fromString,
  propertySearchSortOrder_decode: propertySearchSortOrder_decode,
  propertySearchSortOrder_fromString: propertySearchSortOrder_fromString,
  rentalPropertyFilterableStatus_decode: rentalPropertyFilterableStatus_decode,
  rentalPropertyFilterableStatus_fromString: rentalPropertyFilterableStatus_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "areaIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forSalePropertyTypes"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forSaleStatuses"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keywords"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxBeds"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxPrice"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minBeds"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minPrice"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offMlsOnly"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalMode"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalPropertyTypes"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalStatuses"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortOrder"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useForSaleInventory"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useForSaleProperties"
},
v19 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v20 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v21 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v22 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v23 = [
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "kind": "Variable",
  "name": "areaIds",
  "variableName": "areaIds"
},
v25 = {
  "kind": "Variable",
  "name": "keywords",
  "variableName": "keywords"
},
v26 = {
  "kind": "Variable",
  "name": "maxBeds",
  "variableName": "maxBeds"
},
v27 = {
  "kind": "Variable",
  "name": "maxPrice",
  "variableName": "maxPrice"
},
v28 = {
  "kind": "Variable",
  "name": "minBeds",
  "variableName": "minBeds"
},
v29 = {
  "kind": "Variable",
  "name": "minPrice",
  "variableName": "minPrice"
},
v30 = {
  "kind": "Variable",
  "name": "offMlsOnly",
  "variableName": "offMlsOnly"
},
v31 = {
  "kind": "Variable",
  "name": "sortOrder",
  "variableName": "sortOrder"
},
v32 = [
  (v19/*: any*/),
  (v24/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v25/*: any*/),
  (v22/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  {
    "kind": "Variable",
    "name": "propertyTypes",
    "variableName": "forSalePropertyTypes"
  },
  (v31/*: any*/),
  {
    "kind": "Variable",
    "name": "statuses",
    "variableName": "forSaleStatuses"
  }
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v34/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v38/*: any*/)
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "beds",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baths",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "LotSize",
  "kind": "LinkedField",
  "name": "lotSizeV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v44 = [
  (v40/*: any*/),
  (v41/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "halfBaths",
    "storageKey": null
  },
  (v42/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "livingArea",
    "storageKey": null
  },
  (v43/*: any*/)
],
v45 = {
  "kind": "InlineFragment",
  "selections": (v44/*: any*/),
  "type": "CondoProperty",
  "abstractKey": null
},
v46 = {
  "kind": "InlineFragment",
  "selections": (v44/*: any*/),
  "type": "SingleFamilyProperty",
  "abstractKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfUnits",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyType",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v42/*: any*/),
        (v43/*: any*/)
      ],
      "type": "LotProperty",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v47/*: any*/),
        (v43/*: any*/)
      ],
      "type": "MultiUnitProperty",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v49 = [
  (v40/*: any*/),
  (v41/*: any*/)
],
v50 = {
  "kind": "InlineFragment",
  "selections": (v49/*: any*/),
  "type": "CondoProperty",
  "abstractKey": null
},
v51 = {
  "kind": "InlineFragment",
  "selections": (v49/*: any*/),
  "type": "SingleFamilyProperty",
  "abstractKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyType",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v50/*: any*/),
    (v51/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v47/*: any*/)
      ],
      "type": "MultiUnitProperty",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v53 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v54 = {
  "kind": "Literal",
  "name": "width",
  "value": 60
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipStatus",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "Agent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v37/*: any*/),
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brokerage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfilePhoto",
      "kind": "LinkedField",
      "name": "profilePhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            (v53/*: any*/),
            (v54/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": "urlWithRing",
          "args": [
            (v53/*: any*/),
            {
              "kind": "Literal",
              "name": "ring",
              "value": true
            },
            (v54/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v55/*: any*/),
    (v56/*: any*/)
  ],
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibilityRule",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "agentV2",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v57/*: any*/),
        (v58/*: any*/)
      ],
      "type": "VisibleForSalePropertyAgent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v55/*: any*/)
      ],
      "type": "AnonymousForSalePropertyAgent",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v60 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v61 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "crop",
      "value": false
    },
    {
      "kind": "Literal",
      "name": "embed",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "height",
      "value": 468
    },
    (v53/*: any*/),
    {
      "kind": "Literal",
      "name": "width",
      "value": 648
    }
  ],
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": (v60/*: any*/),
  "concreteType": "PropertyImageConnection",
  "kind": "LinkedField",
  "name": "images",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PropertyImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageAttachment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v61/*: any*/),
            (v62/*: any*/),
            (v56/*: any*/),
            (v38/*: any*/)
          ],
          "storageKey": null
        },
        (v63/*: any*/)
      ],
      "storageKey": null
    },
    (v64/*: any*/)
  ],
  "storageKey": "images(first:1)"
},
v66 = {
  "alias": null,
  "args": (v60/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "PropertySearchCard_images",
  "kind": "LinkedHandle",
  "name": "images"
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "mlsPlan",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "onMlsAt",
          "storageKey": null
        }
      ],
      "type": "ListOnMlsAsActive",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activeOnMlsOn",
          "storageKey": null
        }
      ],
      "type": "ListOnMlsAsComingSoon",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeOnMlsSince",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v70 = [
  (v69/*: any*/)
],
v71 = {
  "kind": "InlineFragment",
  "selections": (v70/*: any*/),
  "type": "PropertyLocationWithHiddenAddress",
  "abstractKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyLocation",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v71/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v69/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        (v58/*: any*/)
      ],
      "type": "PropertyLocationWithVisibleAddress",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "broadcastAt",
  "storageKey": null
},
v75 = [
  (v37/*: any*/),
  (v56/*: any*/)
],
v76 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "SHORT"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"SHORT\")"
  }
],
v77 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPropertyPrice"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "minPrice",
          "plural": false,
          "selections": (v76/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "maxPrice",
          "plural": false,
          "selections": (v76/*: any*/),
          "storageKey": null
        }
      ],
      "type": "PriceRange",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "format",
                  "value": "FULL"
                }
              ],
              "kind": "ScalarField",
              "name": "formatted",
              "storageKey": "formatted(format:\"FULL\")"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "ExactPrice",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    (v77/*: any*/)
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
},
v79 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "agentV2Id",
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "agentV2",
      "plural": false,
      "selections": [
        (v38/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agent",
              "kind": "LinkedField",
              "name": "agent",
              "plural": false,
              "selections": (v75/*: any*/),
              "storageKey": null
            }
          ],
          "type": "VisibleForSalePropertyAgent",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v78/*: any*/)
  ],
  "type": "ForSalePropertyV5",
  "abstractKey": null
},
v80 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "agentId",
      "args": null,
      "concreteType": "Agent",
      "kind": "LinkedField",
      "name": "agent",
      "plural": false,
      "selections": (v75/*: any*/),
      "storageKey": null
    },
    (v78/*: any*/)
  ],
  "type": "RentalPropertyV5",
  "abstractKey": null
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    (v38/*: any*/),
    (v65/*: any*/),
    (v66/*: any*/),
    (v67/*: any*/),
    (v68/*: any*/),
    (v72/*: any*/),
    (v72/*: any*/),
    (v73/*: any*/),
    (v74/*: any*/),
    (v79/*: any*/),
    (v80/*: any*/)
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "developer",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedCompletion",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v85 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageAttachment",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v62/*: any*/),
      (v61/*: any*/),
      (v56/*: any*/),
      (v38/*: any*/)
    ],
    "storageKey": null
  },
  (v63/*: any*/)
],
v86 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v71/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v70/*: any*/),
      "type": "PropertyLocationWithVisibleAddress",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertiesPageRelayQuery",
    "selections": [
      {
        "args": (v23/*: any*/),
        "kind": "FragmentSpread",
        "name": "PropertiesPageRelayForSale_query"
      },
      {
        "args": (v23/*: any*/),
        "kind": "FragmentSpread",
        "name": "PropertiesPageRelayInventory_query"
      },
      {
        "args": (v23/*: any*/),
        "kind": "FragmentSpread",
        "name": "PropertiesPageRelayRental_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v6/*: any*/),
      (v12/*: any*/),
      (v16/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v13/*: any*/),
      (v18/*: any*/),
      (v17/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "PropertiesPageRelayQuery",
    "selections": [
      {
        "condition": "useForSaleProperties",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v32/*: any*/),
            "concreteType": "ForSalePropertyV5Connection",
            "kind": "LinkedField",
            "name": "searchForSaleProperties",
            "plural": false,
            "selections": [
              (v35/*: any*/),
              (v36/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ForSalePropertyV5Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForSalePropertyV5",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/),
                      (v39/*: any*/),
                      (v48/*: any*/),
                      (v52/*: any*/),
                      (v59/*: any*/),
                      (v56/*: any*/),
                      (v81/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "useForSaleInventory",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v32/*: any*/),
            "concreteType": "ForSaleInventoryConnection",
            "kind": "LinkedField",
            "name": "searchForSaleInventory",
            "plural": false,
            "selections": [
              (v35/*: any*/),
              (v36/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ForSaleInventoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v37/*: any*/),
                          (v39/*: any*/),
                          (v48/*: any*/),
                          (v52/*: any*/),
                          (v59/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v65/*: any*/),
                              (v66/*: any*/),
                              (v56/*: any*/),
                              (v67/*: any*/),
                              (v68/*: any*/),
                              (v72/*: any*/),
                              (v72/*: any*/),
                              (v73/*: any*/),
                              (v74/*: any*/),
                              (v79/*: any*/),
                              (v80/*: any*/)
                            ],
                            "type": "PropertyV5",
                            "abstractKey": "__isPropertyV5"
                          }
                        ],
                        "type": "ForSalePropertyV5",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v37/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitType",
                            "storageKey": null
                          },
                          (v77/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DevelopmentProject",
                            "kind": "LinkedField",
                            "name": "development",
                            "plural": false,
                            "selections": [
                              (v82/*: any*/),
                              (v83/*: any*/),
                              (v56/*: any*/),
                              (v37/*: any*/),
                              (v84/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v56/*: any*/),
                          {
                            "alias": "unitImages",
                            "args": (v60/*: any*/),
                            "concreteType": "DevelopmentProjectSampleUnitImageConnection",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DevelopmentProjectSampleUnitImageEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v85/*: any*/),
                                "storageKey": null
                              },
                              (v64/*: any*/)
                            ],
                            "storageKey": "images(first:1)"
                          },
                          {
                            "alias": "unitImages",
                            "args": (v60/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "DevelopmentUnitSearchResultCard__unitImages",
                            "kind": "LinkedHandle",
                            "name": "images"
                          },
                          (v84/*: any*/),
                          (v86/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "beds",
                            "plural": false,
                            "selections": [
                              (v38/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v40/*: any*/)
                                ],
                                "type": "DevelopmentProjectUnitExactBeds",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "minBeds",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "maxBeds",
                                    "storageKey": null
                                  }
                                ],
                                "type": "DevelopmentProjectUnitBedsRange",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "baths",
                            "plural": false,
                            "selections": [
                              (v38/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v41/*: any*/)
                                ],
                                "type": "DevelopmentProjectUnitExactBaths",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "minBaths",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "maxBaths",
                                    "storageKey": null
                                  }
                                ],
                                "type": "DevelopmentProjectUnitBathsRange",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "squareFeet",
                            "plural": false,
                            "selections": [
                              (v38/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "squareFeet",
                                    "storageKey": null
                                  }
                                ],
                                "type": "DevelopmentProjectUnitExactSquareFeet",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "minSquareFeet",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "maxSquareFeet",
                                    "storageKey": null
                                  }
                                ],
                                "type": "DevelopmentProjectUnitSquareFeetRange",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v57/*: any*/),
                          (v73/*: any*/),
                          (v74/*: any*/)
                        ],
                        "type": "DevelopmentProjectSampleUnit",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v37/*: any*/),
                          (v82/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalProjectUnits",
                            "storageKey": null
                          },
                          (v83/*: any*/),
                          (v77/*: any*/),
                          (v56/*: any*/),
                          {
                            "alias": "projectImages",
                            "args": (v60/*: any*/),
                            "concreteType": "DevelopmentProjectImageConnection",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DevelopmentProjectImageEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v85/*: any*/),
                                "storageKey": null
                              },
                              (v64/*: any*/)
                            ],
                            "storageKey": "images(first:1)"
                          },
                          {
                            "alias": "projectImages",
                            "args": (v60/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "DevelopmentProjectSearchResultCard__projectImages",
                            "kind": "LinkedHandle",
                            "name": "images"
                          },
                          (v84/*: any*/),
                          (v86/*: any*/),
                          (v57/*: any*/),
                          (v73/*: any*/),
                          (v74/*: any*/)
                        ],
                        "type": "DevelopmentProject",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v56/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "rentalMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              (v19/*: any*/),
              (v24/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v25/*: any*/),
              (v22/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              {
                "kind": "Variable",
                "name": "propertyTypes",
                "variableName": "rentalPropertyTypes"
              },
              (v31/*: any*/),
              {
                "kind": "Variable",
                "name": "statuses",
                "variableName": "rentalStatuses"
              }
            ],
            "concreteType": "RentalPropertyV5Connection",
            "kind": "LinkedField",
            "name": "searchRentalProperties",
            "plural": false,
            "selections": [
              (v35/*: any*/),
              (v36/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RentalPropertyV5Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RentalPropertyV5",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/),
                      (v39/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "propertyType",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "propertyType",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v57/*: any*/),
                      (v56/*: any*/),
                      (v81/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1c6488cec3c23b58f1d0d67fb0c5ea3a",
    "id": null,
    "metadata": {},
    "name": "PropertiesPageRelayQuery",
    "operationKind": "query",
    "text": "query PropertiesPageRelayQuery(\n  $areaIds: [ID!]!\n  $maxBeds: Int\n  $minBeds: Int\n  $forSalePropertyTypes: [ForSalePropertyTypeEnumV5!]\n  $forSaleStatuses: [ForSalePropertyV5FilterableStatus!]\n  $rentalPropertyTypes: [RentalPropertyTypeEnumV5!]\n  $rentalStatuses: [RentalPropertyFilterableStatus!]\n  $maxPrice: Int\n  $minPrice: Int\n  $keywords: [String!]\n  $offMlsOnly: Boolean\n  $sortOrder: PropertySearchSortOrder\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $rentalMode: Boolean!\n  $useForSaleProperties: Boolean!\n  $useForSaleInventory: Boolean!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  ...PropertiesPageRelayForSale_query_pbnwq\n  ...PropertiesPageRelayInventory_query_pbnwq\n  ...PropertiesPageRelayRental_query_pbnwq\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n    urlWithRing: url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio, ring: true)\n  }\n  membershipStatus\n}\n\nfragment AnonymousAgentInfoForSaleProperty_anonymousForSalePropertyAgent on AnonymousForSalePropertyAgent {\n  membershipStatus\n}\n\nfragment DevelopmentProjectSearchResultActions_developmentProject on DevelopmentProject {\n  id\n}\n\nfragment DevelopmentProjectSearchResultAgent_developmentProject on DevelopmentProject {\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n}\n\nfragment DevelopmentProjectSearchResultCard_developmentProject on DevelopmentProject {\n  id\n  nodeId\n  projectImages: images(first: 1) {\n    edges {\n      node {\n        key\n        url(width: 648, height: 468, crop: false, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DevelopmentProjectSearchResultTimestamp_developmentProject on DevelopmentProject {\n  updatedAt\n  broadcastAt\n}\n\nfragment DevelopmentProjectSearchResultTitleAndLocation_developmentProject on DevelopmentProject {\n  name\n  location {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n    }\n  }\n}\n\nfragment DevelopmentProjectSearchResult_developmentProject on DevelopmentProject {\n  developer\n  totalProjectUnits\n  estimatedCompletion\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_1tj01C\n  }\n  ...DevelopmentProjectSearchResultCard_developmentProject\n  ...DevelopmentProjectSearchResultTitleAndLocation_developmentProject\n  ...DevelopmentProjectSearchResultAgent_developmentProject\n  ...DevelopmentProjectSearchResultTimestamp_developmentProject\n  ...DevelopmentProjectSearchResultActions_developmentProject\n}\n\nfragment DevelopmentUnitSearchResultActions_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  id\n  development {\n    id\n    nodeId\n  }\n}\n\nfragment DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n}\n\nfragment DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  beds {\n    __typename\n    ... on DevelopmentProjectUnitExactBeds {\n      beds\n    }\n    ... on DevelopmentProjectUnitBedsRange {\n      minBeds\n      maxBeds\n    }\n  }\n  baths {\n    __typename\n    ... on DevelopmentProjectUnitExactBaths {\n      baths\n    }\n    ... on DevelopmentProjectUnitBathsRange {\n      minBaths\n      maxBaths\n    }\n  }\n  squareFeet {\n    __typename\n    ... on DevelopmentProjectUnitExactSquareFeet {\n      squareFeet\n    }\n    ... on DevelopmentProjectUnitSquareFeetRange {\n      minSquareFeet\n      maxSquareFeet\n    }\n  }\n}\n\nfragment DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  id\n  nodeId\n  development {\n    id\n    nodeId\n  }\n  unitImages: images(first: 1) {\n    edges {\n      node {\n        key\n        url(width: 648, height: 468, crop: false, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DevelopmentUnitSearchResultTimestamp_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  updatedAt\n  broadcastAt\n}\n\nfragment DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  unitType\n  name\n  location {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n    }\n  }\n  development {\n    name\n    nodeId\n  }\n}\n\nfragment DevelopmentUnitSearchResult_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  unitType\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_1tj01C\n  }\n  development {\n    developer\n    estimatedCompletion\n    nodeId\n  }\n  ...DevelopmentUnitSearchResultCard_newDevelopmentSampleUnit\n  ...DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentSampleUnit\n  ...DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit\n  ...DevelopmentUnitSearchResultAgent_newDevelopmentSampleUnit\n  ...DevelopmentUnitSearchResultTimestamp_newDevelopmentSampleUnit\n  ...DevelopmentUnitSearchResultActions_newDevelopmentSampleUnit\n}\n\nfragment ForSalePropertyAttributesCondo_condoProperty on CondoProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment ForSalePropertyAttributesLot_lotProperty on LotProperty {\n  lotSizeV2 {\n    value\n    unit\n  }\n  displayName\n}\n\nfragment ForSalePropertyAttributesMultiUnit_multiUnitProperty on MultiUnitProperty {\n  numberOfUnits\n  displayName\n}\n\nfragment ForSalePropertyAttributesSingleFamily_singleFamilyProperty on SingleFamilyProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment ForSalePropertyAttributes_property on ForSalePropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      ...ForSalePropertyAttributesCondo_condoProperty\n    }\n    ... on SingleFamilyProperty {\n      ...ForSalePropertyAttributesSingleFamily_singleFamilyProperty\n    }\n    ... on LotProperty {\n      ...ForSalePropertyAttributesLot_lotProperty\n    }\n    ... on MultiUnitProperty {\n      ...ForSalePropertyAttributesMultiUnit_multiUnitProperty\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_Agent_forSalePropertyV5 on ForSalePropertyV5 {\n  agentV2 {\n    __typename\n    ... on VisibleForSalePropertyAgent {\n      agent {\n        ...AgentInfo_agent\n        ...OwnAnonymousAgentInfo_agent\n        nodeId\n      }\n      visibilityRule\n    }\n    ... on AnonymousForSalePropertyAgent {\n      ...AnonymousAgentInfoForSaleProperty_anonymousForSalePropertyAgent\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_StatusLabel_forSalePropertyV5 on ForSalePropertyV5 {\n  ...PropertyMlsLabel_propertyV5\n  status {\n    __typename\n    ... on ActiveProperty {\n      __typename\n    }\n    ... on ExpiredProperty {\n      __typename\n    }\n    ... on SoldProperty {\n      __typename\n    }\n    ... on UnderContractProperty {\n      __typename\n    }\n    ... on WithdrawnProperty {\n      __typename\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_forSalePropertyV5 on ForSalePropertyV5 {\n  ...PropertySearchResultCard_propertyV5\n  ...ForSalePropertySearchResult_StatusLabel_forSalePropertyV5\n  ...PropertyLocationForCard_propertyV5\n  ...PropertiesSearchMapListPropertyLocation_propertyV5\n  ...PropertyPrice_property_1tj01C\n  ...ForSalePropertyAttributes_property\n  ...PropertiesSearchMapListPropertyAttributes_forSaleProperty\n  ...ForSalePropertySearchResult_Agent_forSalePropertyV5\n  ...PropertySearchResultTimestamp_propertyV5\n  ...PropertySearchResultActions_propertyV5\n  ...UseShouldShowPropertyDetails_propertyV5\n}\n\nfragment OwnAnonymousAgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment PropertiesPageRelayForSale_query_pbnwq on Query {\n  searchForSaleProperties(areaIds: $areaIds, maxBeds: $maxBeds, minBeds: $minBeds, propertyTypes: $forSalePropertyTypes, statuses: $forSaleStatuses, maxPrice: $maxPrice, minPrice: $minPrice, sortOrder: $sortOrder, first: $first, after: $after, before: $before, last: $last, keywords: $keywords, offMlsOnly: $offMlsOnly) @include(if: $useForSaleProperties) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        ...ForSalePropertySearchResult_forSalePropertyV5\n        nodeId\n      }\n    }\n  }\n}\n\nfragment PropertiesPageRelayInventory_query_pbnwq on Query {\n  searchForSaleInventory(areaIds: $areaIds, maxBeds: $maxBeds, minBeds: $minBeds, propertyTypes: $forSalePropertyTypes, statuses: $forSaleStatuses, maxPrice: $maxPrice, minPrice: $minPrice, sortOrder: $sortOrder, first: $first, after: $after, before: $before, last: $last, keywords: $keywords, offMlsOnly: $offMlsOnly) @include(if: $useForSaleInventory) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        __typename\n        ... on ForSalePropertyV5 {\n          id\n          ...ForSalePropertySearchResult_forSalePropertyV5\n        }\n        ... on DevelopmentProjectSampleUnit {\n          id\n          ...DevelopmentUnitSearchResult_newDevelopmentSampleUnit\n        }\n        ... on DevelopmentProject {\n          id\n          ...DevelopmentProjectSearchResult_developmentProject\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n}\n\nfragment PropertiesPageRelayRental_query_pbnwq on Query {\n  searchRentalProperties(areaIds: $areaIds, maxBeds: $maxBeds, minBeds: $minBeds, propertyTypes: $rentalPropertyTypes, statuses: $rentalStatuses, maxPrice: $maxPrice, minPrice: $minPrice, sortOrder: $sortOrder, first: $first, after: $after, before: $before, last: $last, keywords: $keywords, offMlsOnly: $offMlsOnly) @include(if: $rentalMode) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        ...RentalPropertySearchResult_rentalPropertyV5\n        nodeId\n      }\n    }\n  }\n}\n\nfragment PropertiesSearchMapListPropertyAttributes_forSaleProperty on ForSalePropertyV5 {\n  ...ForSalePropertyAttributes_property\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      beds\n      baths\n    }\n    ... on SingleFamilyProperty {\n      beds\n      baths\n    }\n    ... on MultiUnitProperty {\n      numberOfUnits\n    }\n    ... on LotProperty {\n      __typename\n    }\n  }\n}\n\nfragment PropertiesSearchMapListPropertyAttributes_rentalProperty on RentalPropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      beds\n      baths\n    }\n    ... on SingleFamilyProperty {\n      beds\n      baths\n    }\n  }\n}\n\nfragment PropertiesSearchMapListPropertyLocation_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ...UseShouldShowPropertyDetails_propertyV5\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n      address\n      visibilityRule\n    }\n  }\n}\n\nfragment PropertyLocationForCard_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ...UseShouldShowPropertyDetails_propertyV5\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n      address\n      visibilityRule\n    }\n  }\n}\n\nfragment PropertyMlsLabel_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  mlsPlan {\n    __typename\n    ... on AlreadyOnMls {\n      __typename\n    }\n    ... on ListOnMlsAsActive {\n      onMlsAt\n    }\n    ... on ListOnMlsAsComingSoon {\n      activeOnMlsOn\n    }\n    ... on NoMlsPlan {\n      __typename\n    }\n  }\n  activeOnMlsSince\n}\n\nfragment PropertyPrice_price_1tj01C on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_1tj01C\n  }\n}\n\nfragment PropertyPrice_propertyPrice_1tj01C on PropertyPrice {\n  __isPropertyPrice: __typename\n  __typename\n  ... on PriceRange {\n    minPrice {\n      formatted(format: SHORT)\n    }\n    maxPrice {\n      formatted(format: SHORT)\n    }\n  }\n  ... on ExactPrice {\n    price {\n      formatted(format: FULL)\n    }\n  }\n}\n\nfragment PropertyPrice_property_1tj01C on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    ...PropertyPrice_price_1tj01C\n  }\n  ... on RentalPropertyV5 {\n    ...PropertyPrice_price_1tj01C\n  }\n}\n\nfragment PropertySearchResultActions_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  id\n  ... on ForSalePropertyV5 {\n    status {\n      __typename\n      ... on WithdrawnProperty {\n        __typename\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    status {\n      __typename\n      ... on WithdrawnProperty {\n        __typename\n      }\n    }\n  }\n}\n\nfragment PropertySearchResultCard_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  images(first: 1) {\n    edges {\n      node {\n        url(width: 648, height: 468, crop: false, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        key\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n  nodeId\n}\n\nfragment PropertySearchResultTimestamp_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  updatedAt\n  broadcastAt\n}\n\nfragment RentalPropertyAttributes_property on RentalPropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      ...ForSalePropertyAttributesCondo_condoProperty\n    }\n    ... on SingleFamilyProperty {\n      ...ForSalePropertyAttributesSingleFamily_singleFamilyProperty\n    }\n  }\n}\n\nfragment RentalPropertySearchResult_Agent_rentalPropertyV5 on RentalPropertyV5 {\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n}\n\nfragment RentalPropertySearchResult_StatusLabel_rentalPropertyV5 on RentalPropertyV5 {\n  ...PropertyMlsLabel_propertyV5\n  status {\n    __typename\n    ... on ActiveProperty {\n      __typename\n    }\n    ... on ExpiredProperty {\n      __typename\n    }\n    ... on RentedProperty {\n      __typename\n    }\n    ... on WithdrawnProperty {\n      __typename\n    }\n  }\n}\n\nfragment RentalPropertySearchResult_rentalPropertyV5 on RentalPropertyV5 {\n  ...PropertySearchResultCard_propertyV5\n  ...RentalPropertySearchResult_StatusLabel_rentalPropertyV5\n  ...PropertyLocationForCard_propertyV5\n  ...PropertiesSearchMapListPropertyLocation_propertyV5\n  ...PropertyPrice_property_1tj01C\n  ...RentalPropertyAttributes_property\n  ...PropertiesSearchMapListPropertyAttributes_rentalProperty\n  ...RentalPropertySearchResult_Agent_rentalPropertyV5\n  ...PropertySearchResultTimestamp_propertyV5\n  ...PropertySearchResultActions_propertyV5\n  ...UseShouldShowPropertyDetails_propertyV5\n}\n\nfragment UseShouldShowPropertyDetails_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    agentV2Id: agentV2 {\n      __typename\n      ... on VisibleForSalePropertyAgent {\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on AnonymousForSalePropertyAgent {\n        __typename\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    agentId: agent {\n      id\n      nodeId\n    }\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
